// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".con-btn-qty[data-v-3753ef67]{position:absolute;bottom:5px;left:50%;transform:translate(-50%);width:135px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
